"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const { HomePageTour } = require("../tours");
const routeMap = {
  "/": HomePageTour
};
const useLoadedPage = (urlPath) => __async(null, null, function* () {
  const mappedRoute = routeMap[urlPath];
  if (mappedRoute) {
    return yield mappedRoute.steps();
  }
});
export { useLoadedPage };
